export default class API {
    constructor(Auth) {
        this.auth = Auth;
        this.is_enabled = true;
    }

    enabled() {
        return this.is_enabled;
    }

    disabled() {
        if (!this.is_enabled) {
            throw 'The App has timed out. Please reload the page to continue.';
        }
    }

    enable() {
        this.is_enabled = true
    }

    disable() {
        this.is_enabled = false;
    }

    prepareUrl(endpoint, options = {}, is_guest) {
        const query_string = Object.keys(options).map(k => `${k}=${options[k]}`).join('&');
        if (is_guest) {
            return `${process.env.PUBLIC_API_URL}/guest/${endpoint}?guest=true&${query_string}`
        } else {
            return `${process.env.PUBLIC_API_URL}/${endpoint}?${query_string}`
        }
    };

    handleResponse(options) {
        return response => Promise.resolve(response)
            .then(response => options && options.hasOwnProperty('buffer') && options.buffer === true ? response.arrayBuffer() : response.json())
            .then(data => {
                if (options && options.hasOwnProperty('buffer') && options.buffer === true) {
                    return data;
                }
                if (data.result === 'success') {
                    return data;
                } else if (data.result === 'error') {
                    let messages = [data.message];
                    if ('Unauthenticated' === data.message) {
                        this.auth.logout();
                        window.location.href = '/login'
                        throw(data.message);
                    } else if (Array.isArray(data.allowed_personas) && data.allowed_personas.length > 0) {
                        window.location.href = `/invalid-persona?q=${btoa(JSON.stringify({
                            persona: data.allowed_personas[0]
                        }))}`;
                    }
                    if (data.hasOwnProperty('extra') && data.extra.length) {
                        messages = data.extra;
                    }
                    throw(messages.join(', '));
                } else if (data.result === 'logout') {
                    this.auth.logout();
                    window.location.href = '/login'
                    throw(data.message);
                } else {
                    throw('Unknown response status.');
                }
            })
    }

    get(endpoint, options) {
        this.disabled();
        let configs = {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
                "X-Source": process.env.PUBLIC_APP_SOURCE
            }
        }
        if (this.auth.getAccessToken()) {
            configs.headers.Authorization = "Bearer " + this.auth.getAccessToken();
        }
        if (process.env.PUBLIC_USE_CORS_CREDENTIALS) {
            configs.credentials = 'include';
        }

        return fetch(this.prepareUrl(endpoint, options), configs).then(this.handleResponse(options));
    }

    post(endpoint, data, options) {
        this.disabled();
        let configs = {
            method: 'post',
            body: JSON.stringify(data),
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json; charset=utf-8",
                "X-Requested-With": "XMLHttpRequest",
                "X-Source": process.env.PUBLIC_APP_SOURCE
            }
        }
        if (this.auth.getAccessToken()) {
            configs.headers.Authorization = "Bearer " + this.auth.getAccessToken();
        }
        if (process.env.PUBLIC_USE_CORS_CREDENTIALS) {
            configs.credentials = 'include';
        }

        return fetch(this.prepareUrl(endpoint, options), configs).then(this.handleResponse(options));
    }

    put(endpoint, data, options) {
        this.disabled();
        let configs = {
            method: 'put',
            body: JSON.stringify(data),
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json; charset=utf-8",
                "X-Requested-With": "XMLHttpRequest",
                "X-Source": process.env.PUBLIC_APP_SOURCE
            }
        }
        if (this.auth.getAccessToken()) {
            configs.headers.Authorization = "Bearer " + this.auth.getAccessToken();
        }
        if (process.env.PUBLIC_USE_CORS_CREDENTIALS) {
            configs.credentials = 'include';
        }

        return fetch(this.prepareUrl(endpoint, options), configs).then(this.handleResponse(options));
    }

    patch(endpoint, data, options) {
        this.disabled();
        let configs = {
            method: 'PATCH',
            body: JSON.stringify(data),
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json; charset=utf-8",
                "X-Requested-With": "XMLHttpRequest",
                "X-Source": process.env.PUBLIC_APP_SOURCE
            }
        }
        if (this.auth.getAccessToken()) {
            configs.headers.Authorization = "Bearer " + this.auth.getAccessToken();
        }
        if (process.env.PUBLIC_USE_CORS_CREDENTIALS) {
            configs.credentials = 'include';
        }

        return fetch(this.prepareUrl(endpoint, options), configs).then(this.handleResponse(options));
    }

    delete(endpoint, options) {
        this.disabled();
        let configs = {
            method: 'delete',
            headers: {
                "Access-Control-Allow-Origin": "*",
                "X-Requested-With": "XMLHttpRequest",
                "X-Source": process.env.PUBLIC_APP_SOURCE
            }
        }
        if (this.auth.getAccessToken()) {
            configs.headers.Authorization = "Bearer " + this.auth.getAccessToken();
        }
        if (process.env.PUBLIC_USE_CORS_CREDENTIALS) {
            configs.credentials = 'include';
        }

        return fetch(this.prepareUrl(endpoint, options), configs).then(this.handleResponse(options));
    }
}
